(()=>{'use strict';
document.documentElement.classList.add('js');
const config=JSON.parse(document.getElementById('bhc-config')?.textContent||'{}');
if(matchMedia('(max-width:759px)').matches){for(const key of ['add','choose','soldOut','unavailable'])config[key]=config[key+'Mobile']||config[key];}
const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>[...r.querySelectorAll(s)];
const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
const motions=new WeakMap();
function openDialog(id){const d=document.getElementById(id);if(!d)return;const state=motions.get(d);if(state){clearTimeout(state.timer);state.animation?.cancel();}d.classList.remove('closing');if(d.open)return;d.showModal();if(d.classList.contains('drawer')&&!reduced()){motions.set(d,{animation:d.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],{duration:420,easing:'cubic-bezier(.22,1,.36,1)'})});}}
function closeDialog(d){if(!d?.open||d.classList.contains('closing'))return;const finish=()=>{d.close();d.classList.remove('closing');motions.delete(d);};motions.get(d)?.animation?.cancel();if(!d.classList.contains('drawer')||reduced()){finish();return;}d.classList.add('closing');motions.set(d,{timer:setTimeout(finish,280)});}
function setupDialogs(root=document){qa('dialog',root).forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';d.addEventListener('cancel',e=>{e.preventDefault();closeDialog(d);});d.addEventListener('click',e=>{if(e.target!==d)return;const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeDialog(d);});});}
document.addEventListener('click',e=>{const unit=e.target.closest('[data-chart-unit]');if(unit){const wrapper=unit.closest('[data-chart-wrapper]');qa('tbody td',wrapper).forEach(cell=>{if(!cell.dataset.inches)cell.dataset.inches=cell.textContent.trim();const n=Number(cell.dataset.inches);if(Number.isFinite(n))cell.textContent=unit.dataset.chartUnit==='cm'?(n*2.54).toFixed(1):cell.dataset.inches;});qa('thead th',wrapper).forEach(th=>{th.textContent=th.textContent.replace(/\((in|cm)\)/,'('+unit.dataset.chartUnit+')');});qa('[data-chart-unit]',wrapper).forEach(b=>b.setAttribute('aria-pressed',String(b===unit)));return;}const continueLink=e.target.closest('[data-cart-continue]');if(continueLink?.closest('dialog')){e.preventDefault();closeDialog(continueLink.closest('dialog'));return;}const closer=e.target.closest('[data-close]');if(closer){closeDialog(closer.closest('dialog'));return;}const opener=e.target.closest('[data-open]');if(opener){openDialog(opener.dataset.open);return;}const zoom=e.target.closest('[data-zoom-src]');if(zoom){const image=q('[data-zoom-image]');const sourceImage = q('img', zoom);
image.removeAttribute('srcset');
image.removeAttribute('sizes');
image.src =
  sourceImage?.currentSrc ||
  sourceImage?.src ||
  zoom.dataset.zoomSrc;image.alt=q('img',zoom)?.alt||'';openDialog('zoom');}});
async function request(path,body){const r=await fetch(config.root+path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});const result=await r.json();if(!r.ok)throw new Error(result.description||result.message||config.error);return result;}
function renderCart(html){if(!html)throw new Error(config.error);const doc=new DOMParser().parseFromString(html,'text/html');const content=q('[data-cart-content]',doc);if(!content)throw new Error(config.error);qa('[data-cart-slot]').forEach(slot=>slot.replaceChildren(content.cloneNode(true)));const count=content.dataset.count;qa('[data-cart-count]').forEach(el=>el.textContent=count);qa('.bag-button').forEach(el=>el.setAttribute('aria-label',config.bag+' ('+count+')'));}
async function refreshCart(result){let html=result?.sections?.['cart-drawer'];if(!html){const r=await fetch(config.cartUrl+'?section_id=cart-drawer',{headers:{Accept:'text/html'}});if(!r.ok)throw new Error(config.error);html=await r.text();}renderCart(html);}
function cartError(message){qa('[data-cart-error]').forEach(el=>el.textContent=message||'');}
let cartBusy=false;
async function mutateCart(work){if(cartBusy)return;cartBusy=true;cartError('');qa('[data-cart-size],[data-cart-quantity],.checkout').forEach(el=>{el.dataset.wasDisabled=String(el.disabled);el.disabled=true;});try{const result=await work();await refreshCart(result);}catch(err){try{await refreshCart();}catch{}cartError(err.message||config.error);}finally{cartBusy=false;qa('[data-cart-size],[data-cart-quantity],.checkout').forEach(el=>{if(el.dataset.wasDisabled!==undefined){el.disabled=el.dataset.wasDisabled==='true';delete el.dataset.wasDisabled;}});}}
const sectionArgs={sections:['cart-drawer'],sections_url:location.pathname};
document.addEventListener('click',e=>{const remove=e.target.closest('[data-cart-remove]');if(!remove)return;e.preventDefault();const key=remove.closest('[data-key]').dataset.key;mutateCart(()=>request('cart/change.js',{id:key,quantity:0,...sectionArgs}));});
document.addEventListener('change',e=>{if(e.target.matches('[data-cart-quantity]')){const input=e.target;const n=Number(input.value);if(!Number.isInteger(n)||n<0)return;mutateCart(()=>request('cart/change.js',{id:input.closest('[data-key]').dataset.key,quantity:n,...sectionArgs}));}
if(e.target.matches('[data-cart-size]')){const select=e.target,variant=Number(select.value),key=select.closest('[data-key]').dataset.key;const cart=JSON.parse(q('[data-cart-json]',select.closest('[data-cart-content]')).textContent);const item=cart.items.find(i=>i.key===key);if(!item||item.variant_id===variant)return;
mutateCart(async()=>{const added=await request('cart/add.js',{items:[{id:variant,quantity:item.quantity,properties:item.properties||{}}]});const newItem=added.items[0];try{return await request('cart/change.js',{id:key,quantity:0,...sectionArgs});}catch(err){const current=await fetch(config.root+'cart.js').then(r=>r.json());const line=current.items.find(i=>i.key===newItem.key);if(line)await request('cart/change.js',{id:line.key,quantity:Math.max(0,line.quantity-item.quantity)});throw err;}});}});
function setupProduct(root=document){qa('[data-product]',root).forEach(product=>{if(product.dataset.ready)return;product.dataset.ready='true';const variants=JSON.parse(q('[data-variants]',product).textContent),form=q('[data-product-form]',product),add=q('[data-add]',product),sticky=q('[data-sticky-add]',product);let selected=variants.find(v=>v.id===Number(form.elements.id.value)),busy=false;const sizeGroup=qa('[data-option-index]',form).find(g=>q('input',g)?.name.toLowerCase().includes('[size]'));let needsSize=!!sizeGroup&&!new URL(location.href).searchParams.has('variant');if(needsSize){qa('input',sizeGroup).forEach(input=>input.checked=false);q('[data-choice]',sizeGroup).textContent=config.choose;}
const gallery = q('[data-gallery]', product);
const galleryPanels = qa('[data-media-panel]', product);
const galleryImages = new Map(galleryPanels.map(panel => [panel.dataset.mediaPanel, q('.zoom-open img', panel)]));
const imagePromises = new WeakMap();
const WARM_ALL_VARIANT_IMAGES = true;
const SLIDE_DURATION = 320;
let requestedMediaId = galleryPanels.find(panel => !panel.hidden)?.dataset.mediaPanel;
let mediaRequest = 0;
let slideAnimations = [];
let outgoingImage = null;
let swipeDirection = 1;

function stopSlide() {
  slideAnimations.forEach(animation => animation.cancel());
  slideAnimations = [];
  outgoingImage?.remove();
  outgoingImage = null;
}

function warmImage(img, priority = 'low') {
  if (!img) return Promise.resolve();
  img.fetchPriority = priority;
  img.loading = 'eager';
  if (img.complete && img.naturalWidth) return Promise.resolve();
  if (imagePromises.has(img)) return imagePromises.get(img);
  const promise = (img.decode ? img.decode() : new Promise((resolve, reject) => {
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', reject, { once: true });
  })).catch(() => {}).finally(() => imagePromises.delete(img));
  imagePromises.set(img, promise);
  return promise;
}

const media = async (id, direction = swipeDirection) => {
  swipeDirection = 1;
  if (!id) return;
  const next = galleryPanels.find(panel => panel.dataset.mediaPanel === String(id));
  if (!next) return;
  requestedMediaId = String(id);
  const requestId = ++mediaRequest;
  stopSlide();
  const previous = galleryPanels.find(panel => !panel.hidden);
  if (previous === next) return;
  const nextImage = galleryImages.get(String(id));
  await warmImage(nextImage, 'high');
  if (requestId !== mediaRequest || !product.isConnected) return;
  const previousImage = previous && galleryImages.get(previous.dataset.mediaPanel);
  const animate = previousImage && nextImage && nextImage.naturalWidth && !reduced() && typeof next.animate === 'function';
  if (animate) {
    outgoingImage = previousImage.cloneNode(false);
    outgoingImage.removeAttribute('id');
    outgoingImage.alt = '';
    outgoingImage.setAttribute('aria-hidden', 'true');
    outgoingImage.classList.add('gallery-outgoing-image');
    gallery.appendChild(outgoingImage);
  }
  galleryPanels.forEach(panel => {
    panel.hidden = panel !== next;
    if (panel.hidden) qa('video', panel).forEach(video => video.pause());
  });
  qa('[data-media]', product).forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.media === String(id)));
  });
  if (animate) {
    const sign = direction < 0 ? -1 : 1;
    const options = { duration: SLIDE_DURATION, easing: 'cubic-bezier(.22,1,.36,1)' };
    slideAnimations = [
      outgoingImage.animate([{ transform: 'translateX(0)' }, { transform: `translateX(${-100 * sign}%)` }], options),
      next.animate([{ transform: `translateX(${100 * sign}%)` }, { transform: 'translateX(0)' }], options)
    ];
    Promise.allSettled(slideAnimations.map(animation => animation.finished)).then(() => {
      if (requestId === mediaRequest) stopSlide();
    });
  }
};

function canWarmImages() {
  const connection = navigator.connection;
  return !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType);
}
async function warmNearbyImages() {
  if (!product.isConnected || !canWarmImages()) return;
  const index = galleryPanels.findIndex(panel => panel.dataset.mediaPanel === requestedMediaId);
  const ids = WARM_ALL_VARIANT_IMAGES
    ? [...new Set(variants.map(variant => String(variant.media)).filter(id => galleryImages.has(id)))]
    : [galleryPanels[(index + 1) % galleryPanels.length]?.dataset.mediaPanel,
       galleryPanels[(index - 1 + galleryPanels.length) % galleryPanels.length]?.dataset.mediaPanel];
  for (const id of new Set(ids)) {
    if (!product.isConnected || !canWarmImages()) break;
    if (id !== requestedMediaId) await warmImage(galleryImages.get(id));
  }
}
function scheduleImageWarming() {
  if ('requestIdleCallback' in window) window.requestIdleCallback(warmNearbyImages, { timeout: 2000 });
  else setTimeout(warmNearbyImages, 1000);
}
if (document.readyState === 'complete') scheduleImageWarming();
else window.addEventListener('load', scheduleImageWarming, { once: true });

function warmColorOnIntent(event) {
  if (!canWarmImages()) return;
  const label = event.target.closest('.color-option');
  const group = label?.closest('[data-option-index]');
  const input = label && q('input', label);
  if (!group || !input) return;
  const index = Number(group.dataset.optionIndex);
  const variant = variants.find(item => item.options[index] === input.value && item.media);
  if (variant) void warmImage(galleryImages.get(String(variant.media)));
}
form.addEventListener('pointerover', warmColorOnIntent);
form.addEventListener('focusin', warmColorOnIntent);
form.addEventListener('touchstart', warmColorOnIntent, { passive: true });
product.addEventListener('click', event => {
  const arrow = event.target.closest('[data-gallery-step]');

  if (arrow && product.contains(arrow)) {
    if (!window.matchMedia('(min-width: 760px)').matches) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const panels = [
      ...product.querySelectorAll('[data-media-panel]')
    ];

    if (panels.length < 2) return;

    const direction =
      Number(arrow.dataset.galleryStep) < 0 ? -1 : 1;

    /*
     * Use the pending image when the optimized gallery is
     * still loading, so repeated clicks advance correctly.
     * Fall back to the visible panel for the original gallery.
     */
    const currentId =
      typeof requestedMediaId !== 'undefined'
        ? String(requestedMediaId)
        : panels.find(panel => !panel.hidden)?.dataset.mediaPanel;

    let currentIndex = panels.findIndex(
      panel => panel.dataset.mediaPanel === currentId
    );

    if (currentIndex < 0) {
      currentIndex = panels.findIndex(panel => !panel.hidden);
    }

    if (currentIndex < 0) currentIndex = 0;

    const nextIndex =
      (currentIndex + direction + panels.length) % panels.length;

    void media(panels[nextIndex].dataset.mediaPanel, direction);
    return;
  }

  /* Preserve existing thumbnail behavior. */
  const thumb = event.target.closest('[data-media]');

  if (thumb && product.contains(thumb)) {
    void media(thumb.dataset.media);
  }
});
form.addEventListener('change',()=>{needsSize=!!sizeGroup&&!q('input:checked',sizeGroup);const options=qa('[data-option-index]',form).map(group=>{const value=q('input:checked',group)?.value;q('[data-choice]',group).textContent=value||'';return value;});selected=variants.find(v=>v.options.every((value,i)=>value===options[i]||(needsSize&&String(i)===sizeGroup.dataset.optionIndex)));form.elements.id.value=selected?.id||'';const label=!selected?config.unavailable:selected.available?config.add:config.soldOut;add.textContent=label;q('[data-sticky-label]',product).textContent=label;add.disabled=sticky.disabled=!selected?.available;if(selected){q('[data-product-prices]',product).innerHTML=selected.prices;q('[data-sticky-price]',product).textContent=selected.price;media(selected.media);const url=new URL(location.href);url.searchParams.set('variant',selected.id);if(!needsSize)history.replaceState({},'',url);}q('[data-product-error]',product).textContent='';});
form.addEventListener('submit',async e=>{e.preventDefault();if(busy)return;if(needsSize){q('[data-product-error]',product).textContent=config.choose;sizeGroup.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'center'});q('input',sizeGroup)?.focus({preventScroll:true});return;}if(!selected?.available)return;busy=true;add.disabled=sticky.disabled=true;q('[data-product-error]',product).textContent='';try{const payload=new FormData(form);payload.set('sections','cart-drawer');payload.set('sections_url',location.pathname);const r=await fetch(config.root+'cart/add.js',{method:'POST',body:payload,headers:{Accept:'application/json'}});const result=await r.json();if(!r.ok)throw new Error(result.description||config.error);try{await refreshCart(result);openDialog('cart');}catch{location.href=config.cartUrl;}}catch(err){q('[data-product-error]',product).textContent=err.message||config.error;}finally{busy=false;add.disabled=sticky.disabled=!selected?.available;}});
sticky.addEventListener('click',()=>form.requestSubmit());
const buy=q('.buy',product);let frame;const sync=()=>{frame=null;if(!product.isConnected)return;const r=buy.getBoundingClientRect(),header=q('.header')?.getBoundingClientRect();product.classList.toggle('main-buy-visible',r.bottom>Math.max(0,header?.bottom||0)&&r.top<innerHeight);};const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};const observer=new IntersectionObserver(schedule,{threshold:[0,1]});observer.observe(buy);addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);window.visualViewport?.addEventListener('scroll',schedule);document.fonts?.ready.then(schedule);sync();
const SWIPE_CHANGES_COLOR = true;
const LOCK_THRESHOLD = 10;
const SWIPE_THRESHOLD = 50;
const colorGroup = q('.option-color', form);
let gesture = null;
let suppressClickUntil = 0;

gallery.addEventListener('touchstart', event => {
  if (event.touches.length !== 1 || !event.target.closest('.zoom-open')) {
    gesture = null;
    return;
  }
  gesture = { x: event.touches[0].clientX, y: event.touches[0].clientY, axis: null };
}, { passive: true });

gallery.addEventListener('touchmove', event => {
  if (!gesture) return;
  if (event.touches.length !== 1) { gesture = null; return; }
  const dx = event.touches[0].clientX - gesture.x;
  const dy = event.touches[0].clientY - gesture.y;
  if (!gesture.axis) {
    if (Math.max(Math.abs(dx), Math.abs(dy)) < LOCK_THRESHOLD) return;
    gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
  }
  if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
}, { passive: false });

gallery.addEventListener('touchend', event => {
  const current = gesture;
  gesture = null;
  if (!current || current.axis !== 'x' || !event.changedTouches.length) return;
  suppressClickUntil = Date.now() + 400;
  const dx = event.changedTouches[0].clientX - current.x;
  if (Math.abs(dx) < SWIPE_THRESHOLD) return;
  const direction = dx < 0 ? 1 : -1;
  const colors = colorGroup ? qa('input[type="radio"]', colorGroup).filter(input => !input.disabled) : [];
  if (SWIPE_CHANGES_COLOR && colors.length > 1) {
    const index = Math.max(0, colors.findIndex(input => input.checked));
    swipeDirection = direction;
    try { colors[(index + direction + colors.length) % colors.length].click(); }
    finally { swipeDirection = 1; }
  } else if (galleryPanels.length > 1) {
    const index = Math.max(0, galleryPanels.findIndex(panel => panel.dataset.mediaPanel === requestedMediaId));
    void media(galleryPanels[(index + direction + galleryPanels.length) % galleryPanels.length].dataset.mediaPanel, direction);
  }
}, { passive: true });

gallery.addEventListener('touchcancel', () => { gesture = null; }, { passive: true });
gallery.addEventListener('click', event => {
  if (Date.now() < suppressClickUntil) {
    event.preventDefault();
    event.stopPropagation();
  }
}, true);
});}
function setupCountries(root=document){qa('[data-country]',root).forEach(country=>{if(country.dataset.ready)return;country.dataset.ready='true';country.value=country.dataset.default||'';const province=q('[data-province]',country.closest('form'));const update=()=>{let values=[];try{values=JSON.parse(country.selectedOptions[0]?.dataset.provinces||'[]');}catch{}province.replaceChildren(...values.map(([value,label])=>new Option(label,value)));province.closest('label').hidden=values.length===0;province.value=province.dataset.default||'';};country.addEventListener('change',update);update();});}
setupDialogs();setupProduct();setupCountries();document.addEventListener('shopify:section:load',e=>{setupDialogs(e.target);setupProduct(e.target);setupCountries(e.target);});
})();

// Original inline collection filters and grid controls; scoped for editor reloads.
document.addEventListener('click', event => {
 const root=event.target.closest('.legacy-collection'); if(!root)return;
 const toggle=event.target.closest('[data-toggle-filters]');
 if(toggle){const panel=root.querySelector('[data-filter-panel]');if(!panel)return;const open=panel.classList.toggle('open');panel.inert=!open;root.querySelectorAll('[data-toggle-filters]').forEach(button=>button.setAttribute('aria-expanded',String(open)));if(open)panel.querySelector('button')?.focus();else root.querySelector('[data-toggle-filters]')?.focus();}
 const column=event.target.closest('[data-cols]');
 if(column){const grid=root.querySelector('[data-pgrid]');if(grid)grid.dataset.columns=column.dataset.cols;root.querySelectorAll('[data-collection-image]').forEach(image=>image.sizes=column.dataset.cols==='2'?'(max-width: 900px) 50vw, 50vw':'(max-width: 900px) 50vw, 25vw');root.querySelector('[data-pgrid]')?.classList.toggle('cols2',column.dataset.cols==='2');root.querySelectorAll('[data-cols]').forEach(button=>{button.classList.toggle('on',button===column);button.setAttribute('aria-pressed',String(button===column));});}
});
document.addEventListener('keydown', event=>{if(event.key!=='Escape')return;const root=event.target.closest('.legacy-collection');const panel=root?.querySelector('[data-filter-panel].open');if(panel){panel.classList.remove('open');panel.inert=true;root.querySelectorAll('[data-toggle-filters]').forEach(button=>button.setAttribute('aria-expanded','false'));root.querySelector('[data-toggle-filters]')?.focus();}});

// Choose once per page load (also initialize sections reloaded by the theme editor).
function setupRandomHeroes(scope=document){
 scope.querySelectorAll('[data-hero-random="true"]').forEach(hero=>{
  if(hero.dataset.randomReady)return;
  const source=hero.querySelector('[data-hero-products]');if(!source)return;
  let products;try{products=JSON.parse(source.textContent);}catch{return;}
  if(!products.length)return;
  const product=products[Math.floor(Math.random()*products.length)];
  const image=hero.querySelector('[data-hero-image]'),meet=hero.querySelector('[data-hero-meet]'),foot=hero.querySelector('[data-hero-foot]');
  if(!image||!meet||!foot)return;
  image.href=meet.href=foot.href=product.url;image.innerHTML=product.image;
  meet.replaceChildren();
  for(const [device,template] of [['desktop',hero.dataset.meetDesktop],['mobile',hero.dataset.meetMobile]]){
   const span=document.createElement('span');span.className='copy-'+device;span.textContent=(template||'Meet [product]').replaceAll('[product]',product.title);meet.append(span);
  }
  foot.textContent=product.title+' · '+product.price;hero.dataset.randomReady='true';hero.dataset.featuredProduct=product.id;
 });
}
setupRandomHeroes();
document.addEventListener('shopify:section:load',event=>setupRandomHeroes(event.target));

let collectionFrame;
function fitCollectionPanels(){
 document.querySelectorAll('.legacy-collection').forEach(root=>{
  const panel=root.querySelector('[data-filter-panel]'),wrap=root.querySelector('.catwrap');if(!panel||!wrap)return;
  const header=document.querySelector('.header')?.closest('[id^="shopify-section-"]');
  const top=Math.max(0,header?.getBoundingClientRect().bottom||0)+16;
  const available=window.innerHeight-Math.max(top,wrap.getBoundingClientRect().top)-16;
  root.style.setProperty('--filter-top',top+'px');root.style.setProperty('--filter-height',Math.max(240,available)+'px');
 });
}
function queueCollectionFit(){if(collectionFrame)return;collectionFrame=requestAnimationFrame(()=>{collectionFrame=null;fitCollectionPanels();});}
window.addEventListener('scroll',queueCollectionFit,{passive:true});window.addEventListener('resize',queueCollectionFit);document.addEventListener('shopify:section:load',queueCollectionFit);fitCollectionPanels();

document.addEventListener('click',event=>{const button=event.target.closest('[data-cart-step]');if(!button)return;const input=button.closest('.cart-quantity').querySelector('[data-cart-quantity]');if(input.disabled)return;input.value=Math.max(0,Number(input.value)+Number(button.dataset.cartStep));input.dispatchEvent(new Event('change',{bubbles:true}));});

/* Pin a collection product with ?first=product-handle. Add this block once. */
(() => {
  const requests = new Map();
  const initialized = new WeakSet();

  function getProduct(root, handle) {
    const url = new URL(root + 'products/' + encodeURIComponent(handle) + '.js', location.origin);
    if (!requests.has(url.href)) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);
      requests.set(url.href, fetch(url.href, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        signal: controller.signal
      }).then(response => response.ok ? response.json() : null)
        .catch(() => null).finally(() => clearTimeout(timer)));
    }
    return requests.get(url.href);
  }

  function imageURL(source, width) {
    const url = new URL(source, location.href);
    if (!['https:', 'http:'].includes(url.protocol)) throw new Error('Invalid image URL');
    url.searchParams.set('width', String(width));
    return url.href;
  }

  function moveFirst(grid, tile) {
    const image = tile.querySelector('img');
    if (image) { image.loading = 'eager'; image.fetchPriority = 'high'; }
    if (grid.firstElementChild !== tile) grid.prepend(tile);
  }

  async function pin(collection, handle) {
    const grid = collection.querySelector('[data-pgrid]');
    if (!grid || initialized.has(grid)) return;
    initialized.add(grid);
    const findTile = () => [...grid.children].find(tile => tile.matches('a.product') && tile.dataset.handle === handle);

    // Retain the campaign parameter when applying filters or changing pages.
    collection.querySelectorAll('form.finner').forEach(form => {
      let input = form.querySelector('input[name="first"]');
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'first'; form.append(input); }
      input.value = handle;
    });
    collection.querySelectorAll('.pagination a[href]').forEach(link => {
      const url = new URL(link.href, location.href);
      url.searchParams.set('first', handle);
      link.href = url.href;
    });

    const existing = findTile();
    if (existing) { moveFirst(grid, existing); return; }
    const root = collection.dataset.firstRoot || '/';
    const product = await getProduct(root, handle);
    if (!product || !grid.isConnected || product.handle !== handle || typeof product.title !== 'string' || !Number.isFinite(product.price)) return;
    const arrived = findTile();
    if (arrived) { moveFirst(grid, arrived); return; }
    const template = grid.querySelector('a.product') || collection.querySelector('[data-first-product-template]')?.content.querySelector('a.product');
    if (!template) return;
    const tile = template.cloneNode(true);
    tile.removeAttribute('id');
    tile.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
    tile.dataset.handle = product.handle;
    tile.dataset.firstPinned = 'true';
    tile.href = root + 'products/' + encodeURIComponent(product.handle);
    tile.querySelector('.pname').textContent = product.title;

    let money;
    try {
      const formatter = new Intl.NumberFormat(collection.dataset.firstLocale || document.documentElement.lang || 'en', {
        style: 'currency', currency: collection.dataset.firstCurrency || 'USD'
      });
      money = cents => formatter.format(cents / 100);
    } catch { money = cents => (cents / 100).toFixed(2); }
    tile.querySelector('.pprice').textContent = money(product.price);
    const priceWrap = tile.querySelector('.pricewrap');
    let compare = tile.querySelector('.pwas');
    const onSale = Number.isFinite(product.compare_at_price) && product.compare_at_price > product.price;
    if (onSale) {
      if (!compare) { compare = document.createElement('del'); compare.className = 'pwas'; priceWrap.prepend(compare); }
      compare.textContent = money(product.compare_at_price);
      compare.hidden = false;
      compare.style.removeProperty('display');
    } else { compare?.remove(); }

    // Never retain the cloned product's image or responsive sources.
    const mediaBox = tile.querySelector('.tile');
    mediaBox.replaceChildren();
    if (product.featured_image) {
      try {
        const image = document.createElement('img');
        const widths = [300, 450, 600, 900, 1400, 2000];
        image.alt = product.title;
        image.decoding = 'async';
        image.loading = 'eager';
        image.fetchPriority = 'high';
        image.setAttribute('data-collection-image', '');
        image.sizes = grid.dataset.columns === '2' ? '(max-width:900px) 50vw,50vw' : '(max-width:900px) 50vw,25vw';
        image.srcset = widths.map(width => imageURL(product.featured_image, width) + ' ' + width + 'w').join(', ');
        image.src = imageURL(product.featured_image, 600);
        mediaBox.append(image);
      } catch { return; }
    }
    // Remove an empty-results paragraph only after a valid product is ready.
    [...grid.children].filter(element => element.tagName === 'P').forEach(element => element.remove());
    moveFirst(grid, tile);
  }

  function setup(scope = document) {
    const handle = new URLSearchParams(location.search).get('first');
    if (!handle || handle.length > 255 || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
    const collections = [...scope.querySelectorAll('.legacy-collection')];
    if (scope.matches?.('.legacy-collection')) collections.unshift(scope);
    collections.forEach(collection => { void pin(collection, handle).catch(() => {}); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

/* BHC: Shopify related products with collection fallback. */
(() => {
  const selector = '[data-bhc-related]';

  async function loadRelated(section) {
    if (section.dataset.relatedLoading) return;
    section.dataset.relatedLoading = 'true';

    const grid = section.querySelector('.product-grid');
    if (!grid) return;

    // The initial Liquid render already contains the collection fallback.
    section.hidden = !grid.querySelector('.product-card');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(section.dataset.relatedUrl, {
        credentials: 'same-origin',
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Recommendations: ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updatedGrid = html.querySelector('[data-bhc-related] .product-grid');
      if (!section.isConnected) return;

      // The response contains recommendations first, then collection top-ups.
      if (updatedGrid?.querySelector('.product-card')) {
        // Avoid removing a link while someone is navigating it by keyboard.
        if (!grid.contains(document.activeElement)) {
          grid.replaceChildren(...updatedGrid.childNodes);
        }
        section.hidden = false;
      }
      // Empty/malformed responses leave the initial fallback intact.
    } catch (error) {
      // Network failures/timeouts leave the initial fallback intact too.
      if (window.Shopify?.designMode) console.warn('Using collection fallback:', error);
    } finally {
      clearTimeout(timeout);
    }
  }

  function setup(scope = document) {
    const sections = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) sections.unshift(scope);
    sections.forEach(loadRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  } else {
    setup();
  }
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();